(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ln8lv", function(module, exports) {
var $f8f2384b7e2b53f9$var$notifications = document.querySelectorAll(".i-notification");
$f8f2384b7e2b53f9$var$notifications.forEach(function(notification) {
    var closeButtons = notification.querySelectorAll(".i-notification__close");
    closeButtons.forEach(function(closeButton) {
        closeButton.addEventListener("click", function() {
            return notification.remove();
        });
    });
});
window.addEventListener("load", function() {
    setTimeout(function() {
        $f8f2384b7e2b53f9$var$notifications.forEach(function(notification) {
            notification.classList.remove("--hidden");
        });
    }, 1000);
});

});

})();
//# sourceMappingURL=notification-item.b140dd65.js.map
